import axios from "axios";
import {
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  updateDataInIndexedDB,
} from "../Hooks/IndexedDBUtils";
import { parseDate } from "./index";

const { REACT_APP_BASE_URL } = process.env;

export const SYNCABLE_STORE = "syncableTrackingStore";
export const TRACKING_STORE = "trackingStore";

export const buildAttemptPayload = ({ id, ownerId, lastDoorKnocked, lastDoorKnockedBy }) => ({
  id,
  owner_id: ownerId,
  household_attempted_: "true",
  last_door_knocked: parseDate(lastDoorKnocked || new Date().toISOString()),
  last_door_knocked_by: ownerId || lastDoorKnockedBy,
});

export const buildDispositionPayload = ({ id, ownerId, disposition }) => ({
  id,
  owner_id: ownerId,
  household_disposition: disposition || "",
});

// Resolves offline=true when the update was queued for "Synchronize Now" instead of sent
export const saveHouseholdUpdate = async (data, { token, syncableDb, trackingDb }) => {
  if (navigator.onLine === false) {
    const queued = (await fetchDataFromIndexedDB(syncableDb, SYNCABLE_STORE)) || [];
    const existing = queued.find((entry) => entry.id === data.id);
    const entry = { id: data.id, properties: { ...(existing?.properties || {}), ...data } };
    delete entry.properties.id;
    await storeDataInIndexedDB(syncableDb, SYNCABLE_STORE, [
      ...queued.filter((item) => item.id !== data.id),
      entry,
    ]);
    updateDataInIndexedDB(trackingDb, TRACKING_STORE, data.id, entry);
    return { offline: true };
  }
  await axios.put(`${REACT_APP_BASE_URL}/householdList`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return { offline: false };
};
